export const apiLinkV1 = 'https://api.cryptobrowser.site/api/v1/';
